// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-image-block[data-v-3c71ffec]{border:2px solid #002560}.secondary-image-block[data-v-3c71ffec]{border:2px solid #aaa}.image-block img[data-v-3c71ffec]{width:100%}.image-block.no-upscale img[data-v-3c71ffec]{max-width:100%;width:auto}\n", ""]);
// Exports
module.exports = exports;
